import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CaixaGerenciarRoutingModule } from './caixa-gerenciar-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CaixaGerenciarRoutingModule
  ]
})
export class CaixaGerenciarModule { }
